import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navigation from "./navigation";
import FooterSection from "./footerSection";
import ImpressumSide from "./impressum";
import PrivacyPage from "./privacy";
import HomePage from "./home";
import AboutPage from "./about";
import GoalsPage from "./goals";
import ContactPage from "./contact";
import ServerPage from "./projects/server";
import LanguagestudyPage from "./projects/languageStudy";
import OnlineCasinoPage from "./finalprojects/onlineCasino";
import WohnungUndFahrgemeinschaftenPage from "./finalprojects/wohnungUndFahrgemeinschaften";
import KrimiDinnerPage from "./projects/krimiDinner";
import LanguageRoleplayPage from "./projects/languageRoleplay";
import TdotPage from "./projects/tdot";

function Home() {
  return <HomePage />;
}


function About() {
  return <AboutPage />;
}

function Goals() {
  return <GoalsPage />;
}

function Contact() {
  return <ContactPage />;
}

function Impressum() {
  return <ImpressumSide />;
}

function Privacy() {
  return <PrivacyPage />;
}

function LanguageStudy() {
  return <LanguagestudyPage />;
}

function Server() {
  return <ServerPage />;
}

function OnlineCasino() {
  return <OnlineCasinoPage />;
}

function WohnungUndFahrgemeinschaften() {
  return <WohnungUndFahrgemeinschaftenPage />
}

function KrimiDinner() {
  return <KrimiDinnerPage />
}

function LanguageRoleplay() {
  return <LanguageRoleplayPage />
}

function Tdot() {
  return <TdotPage />
}

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navigation />
        <div className="flex-grow content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-me" element={<About />} />
            <Route path="/goals" element={<Goals />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/projects/languagestudy" element={<LanguageStudy />} />
            <Route path="/projects/server" element={<Server />} />
            <Route path="/finalprojects/onlineCasino" element={<OnlineCasino />} />
            <Route path="/finalprojects/wufg" element={<WohnungUndFahrgemeinschaften />} />
            <Route path="/projects/crime-dinner" element={<KrimiDinner />} />
            <Route path="/projects/language-roleplay" element={<LanguageRoleplay />} />
            <Route path="/projects/tdot" element={<Tdot />} />
          </Routes>
        </div>
        <FooterSection />
      </div>
    </Router>
  );
}

export default App;